<template>
    <div class="content">
        <div class="member-welfare">
            <div :class="`part-card member-0${userLevel}`">
                <div class="info-card fix">
                    <div class="card-item user-level l fix">
                        <i :class="`icon icon-member icon-member-0${userLevel} l`"></i>
                        <div class="rank-text l">
                            <div class="wel-text">尊敬的：{{ customerInfo.fullName }}</div>
                            <div class="level-text">
                                <h3>{{customerInfo.userLevel}}</h3>
                                <div class="level-rule" @click="showRule">
                                    <i class="icon icon-tip"></i>
                                    <span>等级规则</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-item user-expire-date l">
                        <div class="item-title">等级结算日</div>
                        <div class="item-text">{{formatTime(customerInfo.levelExpireDate)}}</div>
                    </div>
                    <div class="card-item user-level-des l">
                        <div class="des-wrap" v-if="userLevel !== 4">
                            <div class="item-title">距升级Lv{{ userLevel + 1 }}还差</div>
                            <div class="item-text"><span>{{ customerInfo.validShipCount }}次出行</span><a class="btn-item btn-up-level" href="/Rccl.Cruise/CruiseSearch/Search">立即升级</a></div>
                        </div>
                        <div class="des-wrap" v-else>
                            <div class="item-title">距保级还差</div>
                            <div class="item-text"><span>1次出行</span><a class="btn-item btn-up-level" href="/Rccl.Cruise/CruiseSearch/Search">立即预订</a></div>
                        </div>
                    </div>
                    <div class="card-item user-welfare-times l">
                        <div class="item-title">可享福利</div>
                        <div class="item-text">{{customerInfo.welfareCount}}项</div>
                    </div>
                </div>
                <div class="rule-layer" v-if="ruleShow">
                    <div class="content-wrap">
                        <div class="content-scroll">
                            <div class="level-list">
                                <ul class="fix">
                                    <li v-for="(item, index) in levelList" :key="index">
                                        <i :class="`icon icon-level level-0${index + 1}`"></i>
                                        <h3 :class="`level-0${index + 1}`">{{item.levelCN}}</h3>
                                        <p class="level-tip"><span v-if="index !== 0">等级有效期内</span><br>出行次数</p>
                                        <p class="times" v-html="item.times"></p>
                                        <p class="welfare-tip">享受福利</p>
                                        <p class="welfare">{{item.privilegeCount}}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="part-detail">
                                <p>1. “皇家游享荟”会员等级可分为初级会员、高级会员、精英会员和卓越会员；会员需完善信息后，方可累积会员等级所需的出行次数。</p>
                                <p>2. 等级有效期：自等级生效期起两年，如2020年6月5日升级为高级会员，则2022年6月5日该等级到期。</p>
                                <p style="margin-bottom: 0;">3. 满足如下条件，即可成为相应等级的会员：</p>
                                <p style="margin-bottom: 0;">初级会员: 注册成功即成为初级会员，在等级有效期内完成0次符合资格的出行</p>
                                <p style="margin-bottom: 0;">高级会员: 在等级有效期内完成1次符合资格的出行</p>
                                <p style="margin-bottom: 0;">精英会员: 在等级有效期内完成2-3次符合资格的出行</p>
                                <p>卓越会员: 在等级有效期内至少完成4次及以上符合资格的出行</p>
                                <p style="margin-bottom: 0;">4. 会员等级的升级、降级和保级规则</p>
                                <p style="margin-bottom: 0; text-indent: 1em;">4.1 升级规则：用户在原等级有效期内达到下一等级条件，则新的等级立即生效，并从升级当日计算新等级的有效期。</p>
                                <p style="margin-bottom: 0; text-indent: 1em;">4.2 保级规则（适用于精英会员及以上等级）：在等级有效期2年内至少有一次符合资格的出行；若满足该保级规则，则原等级有效期再延长2年。</p>
                                <p style="text-indent: 1em;">4.3 降级规则（适用于高级会员及以上等级）：有效期到期且不满足保级或升级条件的，会员等级自动下降一个级别，并从降级当日计算新等级有效期；初级会员无降级规则。</p>
                                <p style="margin-bottom: 0;">5.“符合资格的出行”指：</p>
                                <p>会员出行的航次，属于“符合资格的预订”下的航次，即构成符合资格的出行。</p>
                                <p>6. 会员等级将在会员离船日起10日后自动更新；若会员等级未自动更新的，可在离船日起12个月内申请会员等级补登，逾期不予办理，补登办理过程中，会员应根据皇家的要求提供相关的凭证。</p>
                            </div>
                        </div>
                        <a class="btn-item btn-close" href="javascript: void(0)" @click="closeRuleLayer"></a>
                    </div>
                </div>
            </div>
            <div class="part-level">
                <span v-bind:class="{cur: tabLevel === 1}" @click="showLevel(1)">初级会员</span>
                <span v-bind:class="{cur: tabLevel === 2}" @click="showLevel(2)">高级会员</span>
                <span v-bind:class="{cur: tabLevel === 3}" @click="showLevel(3)">精英会员</span>
                <span v-bind:class="{cur: tabLevel === 4}" @click="showLevel(4)">卓越会员</span>
            </div>
            <div class="part-privilege">
                <div class="privilege-title"><span :class="`cur cur-0${ tabLevel }`">{{ getLevelText(tabLevel) }}</span>尊享{{ welfareCount }}项福利</div>
                <div class="privilege-list">
                    <ul class="fix">
                        <li :class="`type-0${ tabLevel } ${ item.enjoyPrivilege ? 'cur' : '' }`" v-for="(item, index) in privilegeList" :key="index" @click="showWelfare(item.id)">
                            <div class="icon-box">
                                <img :src="item.enjoyPrivilege ? item.outIcon : item.outGrayIcon" :alt="item.name">
                                <div class="item-tip vc" v-bind:class="{maxWidth: tabLevel !== 1}" v-if="index === 0">{{tabLevel === 1 ? '$50' : '95折'}}</div>
                            </div>
                            <div class="text-box">{{ item.name }}</div>
                        </li>
                    </ul>
                    <div class="welfare-layer" v-if="welfareShow">
                        <div class="content-wrap">
                            <div class="welfare-detail">
                                <div class="layer-title">
                                    <div class="icon icon-welfare">
                                        <img :src="privilege.outBlackIcon" :alt="privilege.name" :title="privilege.name">
                                    </div>
                                    <span>{{privilege.name}}</span>
                                </div>
                                <div class="layer-detail">
                                    <ul>
                                        <li>
                                            <div class="item-title">福利内容</div>
                                            <div class="item-detail" v-html="privilege.content"></div>
                                        </li>
                                        <li>
                                            <div class="item-title">使用说明</div>
                                            <div class="item-detail" v-html="privilege.useDirections"></div>
                                        </li>
                                        <li>
                                            <div class="item-title">福利规则</div>
                                            <div class="item-detail" v-html="privilege.rule"></div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="btn-wrap" v-if="privilege.immediatelyUseFlag && checkType(privilege.type, tabLevel)">
                                    <a class="btn-item btn-use" :href="privilege.immediatelyUseLink">立即使用</a>
                                </div>
                            </div>
                            <a class="btn-item btn-close" href="javascript: void(0)" @click="closeWelfareLayer"></a>
                        </div>
                    </div>
                </div>
                <div class="welfare-des">
                    <a href="/cas/benefits" target="_blank"><img class="bottom-logo" :src="logo" alt="logo"><span>查看皇冠铁锚俱乐部全球会员权益</span></a>
                </div>
            </div>
        </div>
        <Loading :loading="loading"></Loading>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import { dateFormat } from '@/libs/tools'
    import logo from '@/assets/images/logo_50.png'
    import { mapMutations } from 'vuex'
    import Loading from '@/components/loading'
    export default {
        name: 'memberWelfare',
        components: {
            Loading
        },
        data: () => {
            return {
                customerInfo: {},
                userLevel: 1,
                tabLevel: 1,
                welfareCount: 0,
                privilegeList: [],
                logo,
                ruleShow: false,
                timesList: [
                    {
                        times: '0次'
                    },
                    {
                        times: '1次'
                    },
                    {
                        times: '2-3次'
                    },
                    {
                        times: '4次及以上'
                    }
                ],
                levelList: [],
                privilege: {},
                welfareShow: false,
                loading: false
            }
        },
        mounted () {
            this.loading = true

            this.checkCustomerInfo()
                .then(res => {
                    if (!res) {
                        let href = window.location.href
                        window.location.href = `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(href)}`
                    }
                })

            this.getUserLevelPrivilege()
                .then(res => {
                    this.customerInfo = res.customerInfo
                    this.userLevel = this.getLevel(res.customerInfo.userLevel)

                    // 初始化
                    this.tabLevel = this.userLevel
                    this.welfareCount = this.customerInfo.welfareCount

                    // 存储信息
                    this.storeInfo(res.customerInfo)
                    this.storePrivilegeList(res.privilegeList)
                })
            this.getUserMobile()
                .then(res => {
                    if (!this.customerInfo.fullName) {
                        this.customerInfo.fullName = res.mobile
                        this.customerInfo = Object.assign({}, this.customerInfo)

                        // 存储信息
                        this.storeInfo(this.customerInfo)
                    }
                })
            this.getUserPrivilegeList()
                .then(res => {
                    this.privilegeList = res.privilegeList
                })
            this.getUserLevelRule()
                .then(res => {
                    this.levelList = res
                    this.combineObject(this.levelList, this.timesList)

                    this.loading = false
                })
        },
        methods: {
            ...mapMutations(['storeInfo', 'storePrivilegeList']),
            getLevel (userLevelText) {
                switch (userLevelText) {
                    case '初级会员':
                        return 1
                    case '高级会员':
                        return 2
                    case '精英会员':
                        return 3
                    case '卓越会员':
                        return 4
                }
            },
            getLevelText (level) {
                switch (level) {
                    case 1:
                        return '初级会员'
                    case 2:
                        return '高级会员'
                    case 3:
                        return '精英会员'
                    case 4:
                        return '卓越会员'
                }
            },
            formatTime (str) {
                let time = new Date(str).getTime()
                return dateFormat(time, 'YYYY.MM.DD')
            },
            showRule () {
                this.ruleShow = true
            },
            closeRuleLayer () {
                this.ruleShow = false
            },
            combineObject (obj1, obj2) {
                obj1.map((item, index) => {
                    Object.assign(item, obj2[index])
                });
            },
            showWelfare (id) {
                this.getPrivilegeById(id)
                    .then(res => {
                        this.welfareShow = true
                        this.privilege = res
                    })
            },
            closeWelfareLayer () {
                this.welfareShow = false
                this.privilege = {}
            },
            checkType (type, userLevel) {
                if (type === 0 || type === 1 && userLevel === 1 || type === 2 && userLevel !== 1) return true
            },
            showLevel (level) {
                this.tabLevel = level
                this.getNeedLevelPrivilege(`T${level}`)
                    .then(res => {
                        this.privilegeList = res
                        this.welfareCount = this.statisticsAmount(res)
                    })
            },
            statisticsAmount (list) {
                let amount = 0
                for (let i = 0, len = list.length; i < len; i++) {
                    if (list[i].enjoyPrivilege) {
                        amount++
                    }
                }
                return amount
            },
            getUserLevelPrivilege () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserLevelPrivilege',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getUserMobile () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/Rccl.OpenApi/User/GetUserPoint',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.success) {
                                resolve(data.data)
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getUserPrivilegeList () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPrivilegeList',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getUserLevelRule () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerLevel/ApiGetUserLevelRule',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getPrivilegeById (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/Privilege/ApiGetPrivlegeById',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            Id
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            checkCustomerInfo () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiCheckCustomerInfo',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getNeedLevelPrivilege (levelEN) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerLevel/ApiGetNeedLevelPrivilege',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId,
                            levelEN
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
.member-welfare{
    padding-bottom: 84px;
    ::-webkit-scrollbar {
        display: none;
        -webkit-appearance: none;
        appearance: none;
    }
    ::-webkit-scrollbar:vertical {
        width: 2px;
    }
    ::-webkit-scrollbar:horizontal {
        height: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 1px;
        border: 1px solid rgba(255, 255, 255, 0.5);
    }
    ::-webkit-scrollbar-track {
        border-radius: 1px;
        background-color: rgba(255, 255, 255, 0.8);
    }
    ::-webkit-scrollbar-track-piece {
        background-color: rgba(255, 255, 255, 0.8);
        border-left: 1px solid rgba(255, 255, 255, 0.8);
    }
    .part-card{
        padding-top: 23px;
        padding-bottom: 17px;
        background-color: #fff;
        .card-item{
            height: 78px;
            position: relative;
            .item-title{
                color: #747d80;
                line-height: 18px;
            }
            .item-text{
                padding-top: 12px;
                font-size: 16px;
                color: #ffa70d;
                font-weight: bold;
                line-height: 22px;
                span{
                    display: inline-block;
                    vertical-align: middle;
                }
                .btn-up-level{
                    display: inline-block;
                    width: 86px;
                    height: 22px;
                    margin-left: 8px;
                    background-color: #fbc500;
                    border-radius: 11px;
                    color: #282b2c;
                    font-size: 12px;
                    font-weight: normal;
                    line-height: 22px;
                    text-align: center;
                }
            }
            &::after{
                content: "";
                display: block;
                position: absolute;
                right: 0;
                top: 50%;
                width: 1px;
                height: 53px;
                margin-top: -26px;
                background-color: #d3dadd;
            }
        }
        .user-level{
            width: 347px;
            padding-left: 22px;
            .icon{
                display: block;
                width: 78px;
                height: 78px;
            }
            .rank-text{
                padding-left: 15px;
                padding-top: 10px;
                .wel-text{
                    line-height: 18px;
                }
                h3{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 26px;
                    line-height: 36px;
                }
            }
            .level-rule{
                display: inline-block;
                vertical-align: middle;
                padding-left: 10px;
                cursor: pointer;
                .icon-tip{
                    display: inline-block;
                    vertical-align: middle;
                    width: 14px;
                    height: 14px;
                    margin-right: 3px;
                    background: url("../../assets/images/tip.png") no-repeat;
                }
                span{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;
                    color: #0073bb;
                }
            }
        }
        .user-expire-date{
            width: 168px;
            padding-top: 10px;
            text-align: center;
        }
        .user-level-des{
            width: 238px;
            padding-top: 10px;
            text-align: center;
        }
        .user-welfare-times{
            width: 136px;
            padding-top: 10px;
            text-align: center;
            &::after{
                display: none;
            }
        }
        &.member-01{
            .icon-member{
                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_01.png");
            }
            .rank-text{
                h3{
                    color: #3a5d9b;
                }
            }
        }
        &.member-02{
            .icon-member{
                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_02.png");
            }
            .rank-text{
                h3{
                    color: #5c6376;
                }
            }
        }
        &.member-03{
            .icon-member{
                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_03.png");
            }
            .rank-text{
                h3{
                    color: #8e5543;
                }
            }
        }
        &.member-04{
            .icon-member{
                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_04.png");
            }
            .rank-text{
                h3{
                    color: #a78856;
                }
            }
        }
    }
    .part-level{
        padding: 33px 0 28px;
        margin-top: 20px;
        background-color: #fff;
        text-align: center;
        font-size: 0;
        span{
            display: inline-block;
            width: 200px;
            height: 44px;
            margin-right: 2px;
            background-color: #f0f0f0;
            line-height: 44px;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
            &:first-child{
                border-bottom-left-radius: 22px;
                border-top-left-radius: 22px;
            }
            &:last-child{
                margin-right: 0;
                border-bottom-right-radius: 22px;
                border-top-right-radius: 22px;
            }
            &.cur{
                background-color: #fbc500;
            }
        }
    }
    .part-privilege{
        background-color: #fff;
        .privilege-title{
            font-size: 30px;
            line-height: 46px;
            text-align: center;
            .cur{
                font-weight: bold;
                &.cur-01{
                    color: #3a5d9b;
                }
                &.cur-02{
                    color: #282b2c;
                }
                &.cur-03{
                    color: #8e5543;
                }
                &.cur-04{
                    color: #a78856;
                }
            }
        }
        .privilege-list{
            padding-top: 23px;
            &>ul{
                padding: 0 44px;
                &>li{
                    float: left;
                    width: 16.666666%;
                    height: 156px;
                    padding: 0 16px;
                    margin-bottom: 20px;
                    cursor: pointer;
                    .icon-box{
                        position: relative;
                        width: 88px;
                        height: 88px;
                        margin: 0 auto;
                        border: #d6dddf solid 2px;
                        border-radius: 100%;
                        img{
                            display: block;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            width: 72px;
                            transform: translate(-50%, -50%);
                            -webkit-transform: translate(-50%, -50%);
                        }
                        .item-tip{
                            position: absolute;
                            left: 54px;
                            top: 0;
                            height: 22px;
                            min-width: 40px;
                            padding: 0 10px;
                            border-radius: 11px;
                            background-color: #f00;
                            color: #fff;
                            line-height: 22px;
                            text-align: center;
                            &.maxWidth{
                                min-width: 50px;
                            }
                        }
                    }
                    .text-box{
                        padding-top: 6px;
                        font-size: 16px;
                        line-height: 24px;
                        color: #b5b5b5;
                        text-align: center;
                    }
                    &.type-01{
                        &.cur{
                            .icon-box{
                                border: none;
                                background: url("https://resource.rcclchina.com.cn/logo/PC/privilege_01.png") no-repeat;
                                background-size: 100% 100%;
                            }
                            .text-box{
                                color: #3a5d9b;
                            }
                        }
                    }
                    &.type-02{
                        &.cur{
                            .icon-box{
                                border: none;
                                background: url("https://resource.rcclchina.com.cn/logo/PC/privilege_02.png") no-repeat;
                                background-size: 100% 100%;
                            }
                            .text-box{
                                color: #282b2c;
                            }
                        }
                    }
                    &.type-03{
                        &.cur{
                            .icon-box{
                                border: none;
                                background: url("https://resource.rcclchina.com.cn/logo/PC/privilege_03.png") no-repeat;
                                background-size: 100% 100%;
                            }
                            .text-box{
                                color: #8e5543;
                            }
                        }
                    }
                    &.type-04{
                        &.cur{
                            .icon-box{
                                border: none;
                                background: url("https://resource.rcclchina.com.cn/logo/PC/privilege_04.png") no-repeat;
                                background-size: 100% 100%;
                            }
                            .text-box{
                                color: #a78856;
                            }
                        }
                    }
                }
            }
        }
    }
    .welfare-des{
        padding: 58px 0 90px;
        text-align: center;
        a {
            font-size: 12px;
            color: #000f57;
            line-height: 26px;
            text-decoration: underline;
        }
    }
    .bottom-logo{
        display: inline-block;
        position: relative;
        top: -1px;
        vertical-align: middle;
        width: 14px;
        margin-right: 3px;
    }
    .rule-layer{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        .content-wrap{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 816px;
            padding: 38px 36px 20px;
            margin-left: -283px;
            border-radius: 3px;
            background-color: #fff;
            box-shadow: 0 0 12px rgba(46,65,80,0.17);
            -webkit-box-shadow: 0 0 12px rgba(46,65,80,0.17);
            -moz-box-shadow: 0 0 12px rgba(46,65,80,0.17);
            -o-box-shadow: 0 0 12px rgba(46,65,80,0.17);
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            .content-scroll{
                max-height: 500px;
                overflow-y: scroll;
            }
            .level-list{
                padding-top: 32px;
                ul{
                    padding: 0 58px;
                    li{
                        float: left;
                        position: relative;
                        width: 136px;
                        height: 248px;
                        padding-top: 52px;
                        margin-right: 22px;
                        background-color: #fff;
                        border: #d4dbde solid 1px;
                        border-radius: 6px;
                        box-shadow: 0 0 24px rgba(146, 146, 146, 0.13);
                        -webkit-box-shadow: 0 0 24px rgba(146, 146, 146, 0.13);
                        -moz-box-shadow: 0 0 24px rgba(146, 146, 146, 0.13);
                        -o-box-shadow: 0 0 24px rgba(146, 146, 146, 0.13);
                        text-align: center;
                        &:last-child{
                            margin-right: 0;
                        }
                        .icon-level{
                            position: absolute;
                            left: 50%;
                            top: -34px;
                            width: 80px;
                            height: 80px;
                            transform: translateX(-50%);
                            -webkit-transform: translateX(-50%);
                            &.level-01{
                                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_01.png") no-repeat center center;
                                background-size: 78px 78px;
                            }
                            &.level-02{
                                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_02.png") no-repeat center center;
                                background-size: 78px 78px;
                            }
                            &.level-03{
                                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_03.png") no-repeat center center;
                                background-size: 78px 78px;
                            }
                            &.level-04{
                                background: url("https://resource.rcclchina.com.cn/logo/avatar_lv_04.png") no-repeat center center;
                                background-size: 78px 78px;
                            }
                        }
                        h3{
                            font-size: 18px;
                            line-height: 26px;
                            &.level-01{
                                color: #3a5d9b;
                            }
                            &.level-02{
                                color: #282b2c;
                            }
                            &.level-03{
                                color: #8e5543;
                            }
                            &.level-04{
                                color: #a78856;
                            }
                        }
                        .level-tip{
                            margin-top: 14px;
                            line-height: 18px;
                            color: #747d80;
                        }
                        .times{
                            margin-top: 6px;
                            line-height: 18px;
                            color: #282b2c;
                        }
                        .welfare-tip{
                            margin-top: 24px;
                            line-height: 18px;
                            color: #ffa80f;
                        }
                        .welfare{
                            font-size: 24px;
                            line-height: 34px;
                            color: #ffa80f;
                            font-weight: bold;
                        }
                    }
                }
            }
            .part-detail{
                padding-top: 18px;
                p{
                    margin-bottom: 20px;
                    color: #747d80;
                    line-height: 20px;
                }
            }
        }
    }
    .welfare-layer{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        .content-wrap {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 800px;
            padding: 20px 36px;
            margin-left: -275px;
            border-radius: 3px;
            background-color: #fff;
            box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
            -webkit-box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
            -moz-box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
            -o-box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            .welfare-detail{
                max-height: 500px;
                padding-right: 10px;
                overflow-y: scroll;
            }
            .layer-title{
                padding-bottom: 10px;
                border-bottom: #fac400 solid 1px;
                .icon-welfare{
                    display: inline-block;
                    vertical-align: middle;
                    position: relative;
                    width: 54px;
                    height: 54px;
                    background-color: #fac400;
                    border-radius: 27px;
                    img{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 46px;
                        margin-left: -23px;
                        margin-top: -23px;
                    }
                }
                span{
                    display: inline-block;
                    vertical-align: middle;
                    padding-left: 8px;
                    font-size: 24px;
                    color: #fac400;
                }
            }
            .layer-detail{
                padding-top: 16px;
                padding-bottom: 10px;
                ul{
                    li{
                        margin-bottom: 34px;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        .item-title{
                            margin-bottom: 3px;
                            font-size: 22px;
                            line-height: 32px;
                        }
                        .item-detail{
                            color: #747d80;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }
    .btn-close{
        position: absolute;
        right: 10px;
        top: 10px;
        width: 29px;
        height: 29px;
        background: url("../../assets/images/close.png") no-repeat center center #d3dadd;
        background-size: 16px 16px;
        border-radius: 50%;
    }
}
</style>
